//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  methods: {
    handleFontSize() {
      this.$wechat.ready(() => {
        this.$wechat.invoke('setFontSizeCallback', {
          'fontSize': 0
        })
        this.$wechat.on('menu:setfont', () => {
          this.$wechat.invoke('setFontSizeCallback', {
            'fontSize': 0
          })
        })
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.handleFontSize()
    })
  }
}



// WEBPACK FOOTER //
// ./src/App.vue